import { Injectable } from '@angular/core';

import { ApiService }                    from '../../app-lite/api/api.service';
import { CodeTypeModel }                 from '../../app-lite/core/models/code-type';
import { CustomerMessagesSettingsModel } from '../../app-lite/messages/customer-messages/typings/customer-messages.settings';
import { SessionService }                from '../../app-lite/sessions/session.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyCustomizationsService {
  constructor (
    private apiService    : ApiService,
    private sessionService: SessionService
  ) {}

  getBrandingGroups () : Promise<Array<CodeTypeModel>> {
    return this.apiService.get('/system/branding_group_types')
    .then(groups => {
      groups.push({ code: '', description: 'None' });

      return groups;
    });
  }

  getCustomerMessagesSettings ( companyId = this.sessionService.company().id ) : Promise<CustomerMessagesSettingsModel> {
    return this.apiService.get('/sms_global_account', companyId)
    .then(( settings : CustomerMessagesSettingsModel ) => {
      settings.company_id = companyId;

      return settings;
    });
  }

  getCustomStripeFee ( company : any ) : Promise<string> {
    return this.apiService.get('/workshop_admin/get_custom_transaction_fee_rate', company.id)
    .then(( rate : string ) => rate === 'null' ? '0': rate);
  }

  saveBranding ( company : any ) : Promise<any> {
    return this.apiService.patch('workshop_admin/update_branding_group', {
      branding_group: company.branding_group,
      company_id    : company.id
    })
    .then(() => this.sessionService.refresh());
  }

  saveCustomerMessagesSettings ( settings: CustomerMessagesSettingsModel ): Promise<CustomerMessagesSettingsModel> {
    let result : CustomerMessagesSettingsModel;

    return this.apiService.patch('/sms_global_account', settings)
    .then(( settings : CustomerMessagesSettingsModel ) => {
      result = settings;

      return this.sessionService.refresh();
    })
    .then(() => result);
  }

  saveStripeFee ( fee_rate : string, company : any ) : Promise<any> {
    return this.apiService.patch('/workshop_admin/update_custom_transaction_fee_rate', {
      id      : company.id,
      fee_rate: parseFloat(fee_rate)
    })
    .then(() => this.sessionService.refresh());
  }

  setDataDefaults ( company : any ) : Promise<any> {
    return this.apiService.get('workshop_admin/set_branding_default_templates', company.id);
  }

  setDefaults ( company : any ) : Promise<any> {
    return this.apiService.get('workshop_admin/set_branding_defaults', company.id);
  }
}